import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';

const configService = {
  getConfigs() {
    return axios.get(`${API_V2_URL()}/system/config`);
  },
  createOrUpdateConfigs(formdata) {
    return axios.post(`${API_V2_URL()}/system/config`, formdata);
  },
};

export default configService;



// WEBPACK FOOTER //
// ./src/services/system/ConfigService.js